import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart, ArrowRight, Check, X } from 'lucide-react';
import { Button } from './ui/button';

const CartAddedModal = ({ isOpen, onClose, product, quantity = 1 }) => {
  const navigate = useNavigate();
  
  if (!isOpen || !product) return null;
  
  const handleGoToCart = () => {
    onClose();
    navigate('/warenkorb');
  };
  
  const handleContinueShopping = () => {
    onClose();
  };
  
  // Get price display
  const priceDisplay = product.pricing?.buy || `${product.price || 0} €`;
  
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-20 sm:pt-32 px-4 bg-black/40 backdrop-blur-sm">
      <div 
        className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden animate-in slide-in-from-top-5 fade-in duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-green-500 px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3 text-white">
            <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
              <Check className="w-6 h-6" />
            </div>
            <span className="text-lg font-semibold">Zum Warenkorb hinzugefügt</span>
          </div>
          <button 
            onClick={onClose}
            className="text-white/80 hover:text-white transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        {/* Product Info */}
        <div className="p-6">
          <div className="flex gap-4 mb-6">
            {product.image && (
              <div className="w-24 h-24 rounded-lg overflow-hidden bg-gray-100 flex-shrink-0">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            <div className="flex-1 min-w-0">
              <h3 className="font-bold text-gray-900 text-lg truncate">
                {product.name}
              </h3>
              {product.model && (
                <p className="text-sm text-gray-500">Modell: {product.model}</p>
              )}
              <div className="mt-2 flex items-center gap-3">
                <span className="text-sm text-gray-600">Anzahl: {quantity}</span>
                <span className="text-lg font-bold text-red-600">{priceDisplay}</span>
              </div>
            </div>
          </div>
          
          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              variant="outline"
              onClick={handleContinueShopping}
              className="flex-1 py-3 text-base"
            >
              Weiter einkaufen
            </Button>
            <Button
              onClick={handleGoToCart}
              className="flex-1 bg-red-600 hover:bg-red-700 py-3 text-base"
            >
              <ShoppingCart className="mr-2 w-5 h-5" />
              Zum Warenkorb
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartAddedModal;
